import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const routeTitles: Record<string, string> = {
  '/auth': 'auth.login',
  '/dashboard': 'navigation.dashboard',
  '/profile': 'navigation.profile',
  '/settings/organization': 'navigation.organizationSettings',
  '/settings/features': 'featureFlags.title',
  '/settings': 'navigation.settings',
  '/calendar': 'navigation.calendar',
  '/essays/manage': 'essays.manageTitle',
  '/essays': 'essays.myEssays',
  '/quarterly-scoring/matrix': 'quarterlyScoring.matrix.title',
  '/quarterly-scoring/results': 'quarterlyScoring.results.title',
  '/quarterly-scoring': 'quarterlyScoring.title',
  '/review-360/templates': 'review360.templates',
  '/review-360': 'review360.title',
  '/docs': 'docs.title',
  '/policy': 'policy.title',
  '/performance-review': 'navigation.performanceReview',
  '/review': 'navigation.performanceReview',
  '/tech-radar': 'navigation.techRadar',
  '/review-requests': 'reviewRequests.title',
  '/competency-reviews': 'competencyReviews.title',
  '/grades': 'navigation.grades',
  '/competency-maps': 'navigation.competencyMaps',
  '/competencies': 'competencies.title',
  '/users': 'navigation.users',
  '/teams': 'navigation.teams',
  '/teams/roles': 'navigation.teamRoles',
  '/professions': 'navigation.professions',
  '/departments': 'navigation.departments',
  '/all-goals': 'goals.allGoals',
  '/learning': 'navigation.learning',
};

export const PageTitle: React.FC = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const key = Object.keys(routeTitles)
    .sort((a, b) => b.length - a.length)
    .find((route) => pathname.startsWith(route));

  const pageTitle = key ? t(routeTitles[key]) : undefined;

  return (
    <Helmet>
      <title>{pageTitle ? `${pageTitle} — SkillScape` : 'SkillScape'}</title>
    </Helmet>
  );
};
